import React, { useEffect, useMemo, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Avatar } from '@mui/material';
import { Link } from "react-router-dom";
import LinearProgressWithLabel from '../ProgressBar';

const DEFAULT_PAGE_SIZE = 25;

const CRMGrid = (props) => {
  const [hoveredRowIndex, setHoveredRowIndex] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(props.pageSize || DEFAULT_PAGE_SIZE);
  const rows = Array.isArray(props.gridData) ? props.gridData : [];

  useEffect(() => {
    setPage(0);
  }, [props.gridData]);

  const pageCount = Math.max(1, Math.ceil(rows.length / rowsPerPage) || 1);
  const safePage = Math.min(page, pageCount - 1);

  console.log("approve policy page page", props.gridData[3]?.isApproved);

  const pagedRows = useMemo(() => {
    const start = safePage * rowsPerPage;
    return rows.slice(start, start + rowsPerPage);
  }, [rows, safePage, rowsPerPage]);

  const linkTemplate = (data, col) => {
    if (col.to) {
      return (
        <Link to={col?.appendID ? col.to + data["_id"] : col.to}>
          {data[col.field]}
        </Link>
      );
    }
    return (
      <Link to={props.baseURL + data["_id"]} style={{ textDecoration: 'none', color: 'inherit' }}>
        {data[col.field]}
      </Link>
    );
  };

  return (
    <TableContainer
      component={Paper}
      style={{
        borderTopLeftRadius: '10px',
        borderTopRightRadius: '10px',
        marginTop: '15px',
        marginLeft: '10px',
        marginRight: '10px',
        marginBottom: '20px',
        boxShadow: 'none',
        paddingBottom: '20px',
      }}
    >
      <Table stickyHeader aria-label="sticky table">
        <TableHead style={{ height: '10vh' }}>
          <TableRow>
            {props.gridHeader.length > 0 &&
              props.gridHeader.map((headerObj) => (
                <TableCell key={headerObj.field} style={{ backgroundColor: '#DADADA' }}>{headerObj.headerName}</TableCell>
              ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {pagedRows.length > 0 ? (
            pagedRows.map((row, index) => (
              <TableRow
                key={row._id || row.id || `${safePage}-${index}`}
                onMouseEnter={() => setHoveredRowIndex(index)}
                onMouseLeave={() => setHoveredRowIndex(null)}
                style={{ backgroundColor: index === hoveredRowIndex ? '#F08613' : 'white', height: '5vh' }}
              >
                {props.gridHeader.map((headerObj) => (
                  <TableCell
                    key={headerObj.field}
                    style={{
                      paddingTop: '8px',
                      paddingBottom: '8px',
                      borderBottom: '6px solid rgba(224, 224, 224, 1)',
                      color: row.isApproved || row.isChargedBack
                          ? "black"
                        : '008000'
                    }}
                  >
                    {
                      headerObj.isCheckbox ? (
                        <input
                          type="checkbox"
                          checked={props.selectedIds?.includes(row._id)}
                          onChange={() => props.handleCheckboxChange(row._id)}
                        />
                      ) : headerObj.field === 'img' ? (
                        <Avatar src={row[headerObj.field]} shape="circle" size="large" />
                      ) : headerObj.isLink ? (
                        linkTemplate(row, headerObj)
                      )
                        : headerObj.isProgressBar ? (
                          <LinearProgressWithLabel value={row[headerObj.field]} />
                        )
                          : (
                            row[headerObj.field]
                          )
                    }
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={props.gridHeader.length || 1} align="center">
                No Records Found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={rows.length}
        page={safePage}
        onPageChange={(_, nextPage) => setPage(nextPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={[25, 50, 100]}
      />
    </TableContainer>
  );
};

export default CRMGrid;
